define('customersDetailBodyContactController',[
  'module',
  'underscore',
  'backbone',
  'app',
  'settings',
  'rolesMixin',
  'phoneCallsView',
  'customersDetailBodyContactView',
  'emptyView',
  'customersDetailBodyContactInfoController',
  'customersDetailBodyMailsController',
  'entities/customers/contacts'
], function(
  Module,
  _,
  Backbone,
  App,
  Settings,
  RolesMixin,
  PhoneCallsView,
  DetailsLayoutView,
  EmptyView,
  infoTabController,
  mailsController
) {
  'use strict';

  Module.exports =  {
    
    fetchContact: function(data) {
      var that = this,
      emptyView = new EmptyView(),
      contentRegion = App.regions.getRegion('main').currentView.getRegion('content');
      
      contentRegion.show(emptyView);
      this.data = data;
      this.model = App.request('customers:contacts:get-model:item');
      this.model._fetchModel(data.id, data.secId).done(function() {
          if (contentRegion) {
            that.showContact(data);
          }
      });
    },

    showContact: function(data) {
      this.view = new DetailsLayoutView({
          data: this.data,
          model: this.model
        });
      this.view.listenTo(this.view, 'click:tab', _.bind(this.onTabClick, this));
      App.regions.getRegion('main').currentView.getRegion('content').show(this.view);
      this.displayTabs(data);
    },
    
    displayTabs: function(data) {
      var controllers = {};

     controllers[RolesMixin.DASHBOARD_CUSTOMERS_CUSTOMERS_CONTACTS_INFO] = infoTabController;
     controllers[RolesMixin.DASHBOARD_CUSTOMERS_CUSTOMERS_CONTACTS_MAILS] = mailsController;

     data.model = this.model;

     if(RolesMixin.DASHBOARD_CUSTOMERS_CUSTOMERS_CONTACTS_CALLS === data.tab.role) {
       this.callsView = new PhoneCallsView({phoneNumber: this.model.get('tel')});
       App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('tabContent').show(this.callsView);
     } else {
       controllers[data.tab.role].showTab(data);
     }

     this.tab = data.tab;
    },

    showConntact: function(data) {
      var itemModel = App.request('customers:contacts:get-model:item');
      itemModel._fetchModel(data.id, data.secId).done(function() {
      this.view = new DetailsLayoutView({
          model: itemModel
        });
      });
      App.regions.getRegion('main').currentView.getRegion('content').show(this.view);
    },
    
    onTabClick: function(tab) {
      if (this.data.tab !== tab || this.data.secId) {
        this.data.tab = tab;
        this.data.secId = null;

        this.displayTabs(this.data);
        App.navigate('customers/' + this.data.id + '/contacts/' + 
          this.model.get('secId') + '/details/' + tab.route, {trigger: true});
      }
    }
  };
});
